"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = doLimit;
function doLimit(fn, limit) {
    return function (iterable, iteratee, callback) {
        return fn(iterable, limit, iteratee, callback);
    };
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/async/internal/doLimit.js
// module id = 125
// module chunks = 0